const keysToRemove = [
	'dogFormIdealWeight',
	'dogFormActivity',
	'dogFormAllergies',
	'dogFormBreed',
	'dogFormFedProduct',
	'dogFormBrand',
	'dogFormWeight',
	'dogFormBodyType',
	'dogFormAge',
	'dogFormActivity',
	'dogFormGender',
	'dogFormAllergies',
	'dogFormIllnesses',
	'dogFormReproduction',
	'dogFormBreastfeedingPuppyCount',
]

export const clearDogFormLocalStorage = () =>
	keysToRemove.forEach((key) => {
		console.log('clearing', key)
		localStorage.removeItem(key)
	})
